import { attr, Model } from 'redux-orm';

import fetchWithView from 'redux/utils/fetchWithView';
import generator from 'redux/hor/orm-module';

const {
  reducer,
  fetch,
} = generator({
  name: 'DietanamnezFrequency',
  tableId: 44,
});

export default class DietanamnezFrequency extends Model {
  static modelName = 'DietanamnezFrequency';

  static reducer = reducer;

  static options = {
    idAttribute: 'key',
  }

  static fields = {
    custom_частота: attr(),
  }
}

export const fetchList = fetchWithView(fetch, 'ts5c44cs9r86', {
  useLS: true,
});
